import globalSaga from './global/globalSaga';
import authSaga from './auth/authSaga';
import profileSaga from './profile/profileSaga';
import resourcesSaga from './resources/resourcesSaga';
import productsSaga from './products/productsSaga';
import schoolSaga from './school/schoolSaga';

// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield [
        globalSaga(),
        authSaga(),
        profileSaga(),
        resourcesSaga(),
        productsSaga(),
        schoolSaga()
    ];
}



/** WEBPACK FOOTER **
 ** ./src/core/sagas.js
 **/